import ILSSetsTable from '../components/sets-table';
import ILSTemplatesTable from '../components/templates-table';
import { Tabs } from '../types/tabs';

export const tabs = [
  { label: Tabs.DEALS, component: <ILSSetsTable /> },
  { label: Tabs.DOCUMENTS, component: <ILSTemplatesTable /> }
];
